import React from 'react';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { useNavigate } from 'react-router-dom';
import { getCookie } from 'src/utils/cookies';
import Profile from '../Profile';
import Notifications from '../Notifications';
import NavbarGrouping from './NavbarGrouping';
import { NavBarGroupType } from './types';
import SproutsNavIcon from 'src/assets/SproutsNav.svg';
import { ThemeToggle } from '../ThemeToggle';
import TrailUserCard from './TrailUserCard';
import { useSelector } from 'react-redux';
import { useFeatureFlags } from 'src/hooks/useFeatureFlags';

type Props = {
  navData: NavBarGroupType;
  shouldDisplayDivider: (group: any[]) => boolean;
  trialPeriod: number;
  userTenantType: string;
};

export const CollapsedNavbar = ({ navData, shouldDisplayDivider, trialPeriod, userTenantType  }: Props) => {
  const navigate = useNavigate();
  const token = getCookie('user');
  const {showOldNotifications} = useSelector((state: any) => state.notificationsState);
  const featureFlags = useFeatureFlags();
  return (
    <div className="navbar-v2-collapsed">
      <Grid2 xs={1} height={'100%'} width={'100%'}>
        <div className="nav-bar-container">
          <div className="nav-bar-icons-container">
            <div
              className="navbar-v2-header-wrapper"
              onClick={() => navigate('/target-profiles/accounts')}
            >
              <div className="navbar-v2-header">
                {/* <SproutsNavIcon className="first-icon" width="16" height="21" viewBox="0 0 16 21" /> */}
                <img src={SproutsNavIcon} alt="sprouts-nav-icon" width="16" height="21" />
              </div>
            </div>
            <div className="navbar-v2-groups-container">
              {Object.keys(navData).map((groupKey: string) =>
                groupKey === 'Settings' ? (
                  <React.Fragment key={groupKey} />
                ) : (
                  <NavbarGrouping
                    key={groupKey}
                    group={{ [groupKey]: navData[groupKey] }}
                    expanded={false}
                    shouldDisplayDivider={shouldDisplayDivider(navData[groupKey])}
                  />
                ),
              )}
            </div>
          </div>
          <div className="navbar-v2-profile-wrapper profile-wrapper-collapsed">
            <div className="navbar-v2-profile-nav-items">
              { (userTenantType === 'SELF_SIGN_IN' || trialPeriod > 0) && (
                <TrailUserCard
                  isExpanded={false}
                  description="Need more time ? Contact our team to upgrade your plan"
                  count={trialPeriod}
                  maxCount={7}
                  label="Trial Period: 7 days"
                  className="trail-user-card-collapsed"
                />
              )}
              {(showOldNotifications && featureFlags?.notifications === false) ? <Notifications expanded={false} triggerCollapseNav={() => 0} /> : null}
              {/* <ThemeToggle expanded={false} /> */}
              <NavbarGrouping
                key={'Settings'}
                group={{ ['Settings']: navData['Settings'] }}
                expanded={false}
                shouldDisplayDivider={false}
                shouldShowGroupName={false}
              />
            </div>
            {token ? <Profile expanded={false} triggerCollapseNav={() => 0} /> : <></>}
          </div>
        </div>
      </Grid2>
    </div>
  );
};
